<template>
<div>

  <v-btn
    v-if="!isMissionControlSession && site?.google_docs_folder_url"
    class="project-folder-button button-with-icon mainColor--text text-none"
    small outlined color="mainColor"
    :href="site?.google_docs_folder_url"
    target="_blank"
  >
    <span class="d-flex align-center gap5" style="font-weight: 400;"><img src="/static/google_drive_icon.png" style="width: 20px;" /> Your project folder</span>
  </v-btn>
  <v-btn
    v-else-if="isMissionControlSession"
    class="project-folder-button button-with-icon mainColor--text text-none"
    small outlined color="mainColor"
    @click="showEditModal = true"
  >
    <span class="d-flex align-center gap5" style="font-weight: 400;"><img src="/static/google_drive_icon.png" style="width: 20px;" />Edit project folder</span>
  </v-btn>

  <div v-if="showEditModal && isWhiteGloveUser && isMissionControlSession" class="modal" :class="{'is-active': true}">
    <div class="modal-background" @click.stop="showEditModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <p class="title-font is-size-4 mainColor--text">Google Docs Folder URL</p>
          <div class="mainColor--text" style="font-size: 1rem; line-height: 150%;">
            Insert the Google Docs folder URL for this project (keep empty to hide the button for the user).<br /><br />
            <v-text-field outlined dense
              v-model="urlFieldValue"
              placeholder="Enter URL"
              color="grayColor"
            ></v-text-field>
          </div>
          <div class="d-flex justify-end gap10 mt-5">
            <v-btn rounded outlined color="mainColor"
              class="text-none"
              @click.stop="() => {
                showEditModal = false;
              }">
              <span>Cancel</span>
            </v-btn>
            <v-btn rounded color="profileAnchorColor"
              class="whiteColor--text text-none"
              @click.stop="() => {
                updateSite({google_docs_folder_url: urlFieldValue});
              }"
            >
              <span>Save</span>
            </v-btn>
            
          </div>
        </div>
      </div>
      <button
        class="custom-modal-close-btn"
        aria-label="close"
        @click="() => (showEditModal = false)">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

</div>
</template>

<script>
import { getPureServicePkgName } from '@/utils'
import {
  whiteGlovePlans
} from "@/components/plans_constants";

export default {
  props: ['site'],
  data() {
    return {
      showEditModal: false,
      urlFieldValue: ''
    };
  },
  watch: {
    'site.google_docs_folder_url': {
      handler(newValue, oldValue) {
        this.urlFieldValue = newValue
      },
      immediate: true
    },
  },
  computed: {
    user () {
      if (this.$store.state.user) {
        return this.$store.state.user
      }
      return null
    },
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.$store.state.user
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
  },
  methods: {
    updateSite(payload) {
      this.$store.commit('showLoading');
      return this.$store.dispatch('updateSite', {
        siteId: this.site.id,
        body: payload
      })
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            return this.loadSites().then(() => {
              this.showEditModal = false;
              this.$notify({ group: 'info', type: 'success', text: 'Successfully updated URL.' })
            })
          } else {
            this.$notify({
              group: "info",
              type: "error",
              text: "Failed to save",
            });
          }
        })
        .catch(() => {
          this.$notify({ group: 'info', type: 'error', text: 'An error happened.' })
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        })
    },
    loadSites() {
      return this.$store
        .dispatch("loadSites")
        .then(response => {
          if (response.data && response.data.status === "SUCCESS") {
            this.$store.commit("setSites", response.data.sites);
          }
        })
    },
  },
  mounted () {

  }
};
</script>

<style lang="scss" scoped>
.project-folder-button {
  background-color: var(--v-whiteColor-base);
  margin-right: 15px;
  height: 36px !important;
}
</style>
